module.exports = __webpack_public_path__ + "img/chinesecompany83.af363549.png";